import './styles';

export { useTextStyles } from './hooks';
